import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { isAddress } from "ethers"; // v6+
import { ethers } from "ethers";
import { feeds, NETWORKS, aggregatorV3ABI } from "../contracts/aggregatorV3ABI";
import useContract from "../hooks/useContract";
import {
  useAppKitAccount,
  useAppKitNetwork,
  useDisconnect,
} from "@reown/appkit/react";
import { mainnet, bsc, base, polygon } from "@reown/appkit/networks";



const StakeCalculte = () => {
  const [amount, setAmount] = useState("");
  const { isConnected, address } = useAppKitAccount();


  const [estimatedReward, setEstimatedReward] = useState(null);
const lockupOptions = [
  { label: "1 Month", duration: 30 * 24 * 60 * 60, rewardRate: 12 },
  { label: "2 Months", duration: 60 * 24 * 60 * 60, rewardRate: 18 },
  { label: "3 Months", duration: 90 * 24 * 60 * 60, rewardRate: 24 },
  { label: "6 Months", duration: 180 * 24 * 60 * 60, rewardRate: 36 },
];

const [selectedIndex, setSelectedIndex] = useState(0);
const selectedOption = lockupOptions[selectedIndex]; // ✅ This is derived


  const { chainId, switchNetwork } = useAppKitNetwork();


useEffect(() => {
  if (amount && selectedOption) {
    const { duration, rewardRate } = selectedOption;
    const reward =
      (parseFloat(amount) * rewardRate * duration) / (365 * 24 * 60 * 60 * 100);
    setEstimatedReward(reward.toFixed(2));
  } else {
    setEstimatedReward(null);
  }
}, [amount, selectedOption]);



    const { getVestedAllocation ,getVestedClaimable , getVestedClaimed ,claimvestTokens ,myTokenBalance ,maxBalances ,manualvestTokens} = useContract();

    const [maxBalance, setMaxBalance] = useState(null);
    const [balance, setBalance] = useState(0);

useEffect(() => {
  let intervalId;

  const _balance = async () => {
    const _myBalance = await myTokenBalance();
    console.log(_myBalance);
    setBalance(_myBalance);

    const _maxBalance = await maxBalances();
    console.log(_maxBalance);
    setMaxBalance(_maxBalance);
  };

  if (address) {
    _balance(); // run immediately

    intervalId = setInterval(() => {
      _balance(); // refresh every 10s
    }, 10000);
  }

  return () => {
    if (intervalId) clearInterval(intervalId); // cleanup on unmount or address change
  };
}, [address]);



      const { stakeTokens} = useContract();




        const handleStake = async () => {

          
    try {
       const networks = {
            ETH: { id: 1, name: "Ethereum Mainnet" },
          };
              
      
                if (chainId !== networks.ETH.id) {
                    switchNetwork(mainnet);
                    console.log("🔁 Switching to Ethereum Mainnet...");
                  }
      if (!amount || isNaN(amount) || Number(amount) <= 0) {
        toast.error("Enter a valid amount");
        return;
      }

      const lockupIndex = selectedIndex + 1; // 1-based index
      const txHash = await stakeTokens(amount, lockupIndex);
      toast.success(`Staked successfully! TX: ${txHash.slice(0, 10)}...`);

      setAmount("");
      setEstimatedReward(null);
    } catch (err) {
      console.error("Stake error:", err);
      toast.error("Staking failed. Check console for details.");
    }
  };



  
const formatCompactNumber = (num) => {
  const number = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(number)) return "0";
  if (number >= 1_000_000_000_000) return (number / 1_000_000_000_000).toFixed(2) + "T";
  if (number >= 1_000_000_000) return (number / 1_000_000_000).toFixed(2) + "B";
  if (number >= 1_000_000) return (number / 1_000_000).toFixed(2) + "M";
  if (number >= 1_000) return (number / 1_000).toFixed(2) + "K";
  return number.toFixed(2);
};
  return (
  <section className="w-full px-4 py-10 flex justify-center items-center">
      <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-[1280px] gap-8">
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="img1.png"
            alt="Staking"
            className="max-w-full h-auto rounded-2xl"
          />
        </div>

        <div className="relative w-full max-w-[671px] h-auto sm:h-[614px]">
          <div className="relative w-full h-full bg-[url('https://c.animaapp.com/mckibea3MJAQjg/img/rectangle-45.svg')] bg-cover bg-center">
            <div className="absolute w-[94%] h-[444px] top-[35px] sm:top-[45px] left-[3%] rounded-3xl bg-[url('https://c.animaapp.com/mckibea3MJAQjg/img/freepik--the-style-is-candid-image-photography-with-natural--818.png')] bg-cover bg-center">
              <div className="w-full h-full rounded-3xl bg-gradient-to-r from-[#2b111d]/90 via-[#1f1533]/90 to-[#10242f]/90" />
            </div>

            <div className="flex flex-col w-[94%] mx-auto items-center relative pt-8 sm:pt-10">
              <div className="div-wrapper absolute -top-8 left-1/2 transform -translate-x-1/2 bg-[#1e1a2e] rounded-full px-8 py-3.5 z-10 mt-[25px]">
                <div className="text-white text-[22px] font-medium leading-8 font-['Inter']">
                  STAKING
                </div>
              </div>

              <div className="flex flex-col items-start gap-[42px] pt-[60px] pb-10 px-4 sm:px-10 w-full">
                {/* Amount Input */}
     <div className="flex flex-col gap-2 w-full">
  {/* Header Row */}
  <div className="flex justify-between items-center">
    <div className="text-white text-base leading-8">Amount</div>
    {balance !== null && (
      <div className="text-white text-sm font-medium bg-[#3a3350] px-3 py-1 rounded-full">
        Wallet Balance: {formatCompactNumber(balance)} BABYU
      </div>
    )}
  </div>

  {/* Amount Input */}
  <input
    type="number"
    placeholder="Enter $BABYU Amount"
    className="w-full p-3 bg-[#3a335066] text-white placeholder-[#bebebe] rounded-md backdrop-blur-md"
    value={amount}
    onChange={(e) => setAmount(e.target.value)}
  />
</div>



                {/* Duration Options */}
                <div className="flex flex-col gap-2 w-full">
                  <div className="text-white text-base leading-8">Duration</div>
                  <div className="flex flex-wrap gap-6">
                    {lockupOptions.map((option, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-3 cursor-pointer"
                        onClick={() => setSelectedIndex(index)}
                      >
                        <div className="w-6 h-6 border rounded-xl border-[#d6ecfd] bg-white relative">
                          {selectedIndex === index && (
                            <div className="w-[15px] h-[15px] top-[3px] left-[3px] bg-[rgb(61_224_61)] bg-opacity-80 rounded-full absolute" />
                          )}
                        </div>
                        <div className="text-white text-base leading-8 whitespace-nowrap">
                          {option.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Estimated Rewards */}
                <div className="flex flex-col gap-2 w-full">
                  <div className="text-white text-base leading-8">Estimated Rewards</div>
                  <div className="flex items-center justify-around px-6 py-3 bg-[#3a335066] rounded-md backdrop-blur-md">
                    <div className="text-[#dddddd] text-xl font-semibold">
                      {estimatedReward !== null ? `${estimatedReward} $BABYU` : "—"}
                    </div>
                  </div>
                </div>

                {/* Stake Now Button */}
                <button
                  className="flex items-center justify-center gap-2.5 px-8 py-4 w-full rounded-full border-2 border-white shadow-[0px_4px_16px_#ff49b8] bg-gradient-to-r from-[#ff6eb3] via-[#aa81ff] to-[#6bc9ff] text-white text-[22px] font-semibold"
                  onClick={handleStake}
                  disabled={!amount || isNaN(amount) || Number(amount) <= 0}
                >
                  Stake Now
                  <img
                    className="w-[25px] h-[25px]"
                    alt="Arrow right"
                    src="https://c.animaapp.com/mckibea3MJAQjg/img/arrow-right.svg"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StakeCalculte;
